import { Severity } from '../../types';

export const SeverityTitle = {
  [Severity.Emergency]: 'Emergency - Now',
  [Severity.Urgent]: 'Urgent Care - Soon',
  [Severity.Unknown]: 'I don’t know - let’s triage!',
  [Severity.Appointment]: 'Appointment - When Convenient',
};
